import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { UtilityService } from '../../service/utility.service';
import {
  PortalFeatureDirective,
  PortalLoginRequiredDirective,
  PortalButtonDirective,
} from '../../directives';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [
    CommonModule,
    PortalFeatureDirective,
    PortalLoginRequiredDirective,
    PortalButtonDirective,
  ],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css',
})
export class FooterComponent implements OnInit {
  constructor(private utilityService: UtilityService) {}

  LoggedIn = JSON.parse(localStorage.getItem('login') || 'false');
  ngOnInit(): void {}

  // Direct access to portal configuration
  get portalConfig() {
    return this.utilityService.portalConfig;
  }
}
